export default {
  newsLetter: {},
};
